import Reveal, { Eyebrow } from "./Reveal";
import { ShieldCheck, Database, KeyRound, EyeOff, Archive, Globe, Clock, PhoneOff, Mic, RefreshCcw, FileCheck, FileSignature } from "lucide-react";

const SECURITY = [
  { icon: Database, title: "Multi-tenant, one silo per tenant", body: "One codebase: own database, own subdomain, own secrets. A running campaign stays pinned to its version; new versions never auto-apply." },
  { icon: KeyRound, title: "Secrets and logins", body: "Secrets live in env files with strict permissions — never in code or logs. Logins are JWT-scoped: a user only ever sees their own tenant." },
  { icon: EyeOff, title: "Super Admin is blind", body: "Platform admins cannot see tenant customer data." },
  { icon: Archive, title: "Backups per tenant", body: "Own dumps, versioned, per tenant." },
  { icon: Globe, title: "HTTPS-only webhooks", body: "Webhook calls over plain HTTP are rejected." },
];

const COMPLIANCE = [
  { icon: Clock, title: "Consent and calling window", body: "Calls only inside agreed windows." },
  { icon: PhoneOff, title: "DNC respected", body: "Do-not-call handling built in." },
  { icon: Mic, title: "Every call recorded", body: "Recording + transcript on file for every call." },
  { icon: RefreshCcw, title: "Number rotation", body: "Caller IDs rotate per policy." },
  { icon: FileCheck, title: "Audited everything", body: "Disposition and lifecycle updates, time-bound approvals." },
  { icon: FileSignature, title: "Letters client-end", body: "Settlement letters issued client-side after Team Leader approval (collections pack)." },
];

const List = ({ items, prefix }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-0">
    {items.map((s, i) => (
      <Reveal key={s.title} delay={i * 0.05}>
        <div data-testid={`${prefix}-item-${i + 1}`} className="flex gap-4 py-6 border-b border-zinc-200 items-start">
          <s.icon size={20} className="text-[#2563EB] shrink-0 mt-1" />
          <div>
            <h3 className="font-display font-bold text-base text-zinc-900">{s.title}</h3>
            <p className="text-zinc-600 text-sm mt-1.5 leading-relaxed">{s.body}</p>
          </div>
        </div>
      </Reveal>
    ))}
  </div>
);

const Security = () => (
  <section id="security" data-testid="security-section" className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow>Security</Eyebrow>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
          Your data stays yours.
        </h2>
      </Reveal>
      <div className="mt-12">
        <List items={SECURITY} prefix="security" />
      </div>

      <Reveal className="mt-20">
        <Eyebrow>Compliance & audit</Eyebrow>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl mt-4 leading-[1.08]">
          Built to be audited.
        </h2>
      </Reveal>
      <div className="mt-12">
        <List items={COMPLIANCE} prefix="compliance" />
      </div>
    </div>
  </section>
);

export default Security;
